<div class="related-postings-swipper-container relative">
    <swiper-container [config]="swiperConfig" init="false" class="related-postings-swipper" (slideChangeTransitionEnd)="onSlideChangeTransitionEnd()">
        <swiper-slide
            #postingsRef
            [attr.postId]="postingResource.id"
            *ngFor="let postingResource of article.relatedPostings; index as index; first as isFirst; last as isLast"
            (click)="openPostInDialog(index, isFirst, isLast)"
        >
            <div class="slide-img-layer"></div>
            <div class="slide-img" [style.background-image]="'url(' + postingResource.image.smallUrl + ')'"></div>
            <div class="slide-content">
                <mat-chip-set>
                    <mat-chip [disableRipple]="true">{{ postingResource.postingType.displayNameKeySingular | translate }}</mat-chip>
                </mat-chip-set>
                <h3>{{ postingResource.translation ? postingResource.translation.title : (postingResource.translations[0].title | translate) }}</h3>
                <p [innerHTML]="postingResource.translation ? (postingResource.translation.description | safeHtml) : (postingResource.translations[0].description | safeHtml)"></p>
            </div>
        </swiper-slide>
    </swiper-container>

    <div class="related-postings-swiper-button-next"></div>
    <div class="related-postings-swiper-button-prev"></div>
</div>
